export default "__VITE_ASSET__CW7VFge5__"